import MapIcon from "@heroicons/react/24/solid/MapIcon";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const MapContainer = styling("iframe")({
  borderRadius: "1rem",
  border: `1px solid ${Color.grey}`,

  height: "272px",

  "@media (max-width: 640px)": {
    height: "242px",
  },
});

export const AddressIcon = styling(MapIcon)({
  width: "1.5rem",
  height: "1.5rem",
});
